import { NavigationData } from "@lib/base/components/navigation/sidebar/sidebar.component.types";

export const ADMIN_NAVIGATION_UBI: NavigationData = {
    settings: {
        prefix: "administration-ubi",
    },
    routes: [
        {
            key: "Dashboard",
            route: "dashboard",
            icon: "dashboard",
        },
        {
            key: "routing.administration-ubi.infrastructure._title",
            icon: "graph_4",
            children: [
                {
                    key: "routing.administration-ubi.infrastructure.sites._title",
                    route: "infrastructure/sites",
                    icon: "business",
                    permissions: ["Site"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.managers._title",
                    route: "infrastructure/managers",
                    icon: "storage",
                    permissions: ["Manager"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.stations._title",
                    route: "infrastructure/stations",
                    icon: "router",
                    permissions: ["Station"],
                },
                {
                    key: "routing.administration-ubi.infrastructure.tags._title",
                    route: "infrastructure/tags",
                    icon: "nfc",
                    permissions: ["Tag"],
                },
            ],
        },
        {
            key: "routing.administration-ubi.security._title",
            icon: "security",
            children: [
                {
                    key: "routing.administration-ubi.security.users._title",
                    route: "security/users",
                    icon: "supervisor_account",
                    permissions: ["User"],
                },
                {
                    key: "routing.administration-ubi.security.roles._title",
                    route: "security/roles",
                    icon: "engineering",
                    permissions: ["Role"],
                },
            ],
        },
        {
            key: "routing.administration-ubi.tag-import-history._title",
            icon: "history",
            route: "tag-import-history",
        },
        {
            key: "routing.administration-ubi.tools._title",
            icon: "build",
            children: [
                {
                    key: "routing.administration-ubi.tools.auto-pairing._title",
                    route: "tools/auto-pairing",
                    icon: "sync",
                    permissions: ["DropPoint"],
                },
                {
                    key: "routing.administration-ubi.tools.drop-point-migration._title",
                    route: "tools/drop-point-migration",
                    icon: "published_with_changes",
                    permissions: ["AutomaticMigration"],
                },
                {
                    key: "routing.administration-ubi.tools.bulk-operations._title",
                    route: "tools/bulk-operations",
                    icon: "playlist_remove",
                    permissions: ["Asset"],
                },
            ],
        },
    ],
};
